"use strict";
//
// Copyright © 2024 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCollabId = makeCollabId;
exports.makeDocCollabId = makeDocCollabId;
exports.makeCollabYdocId = makeCollabYdocId;
exports.makeCollabJsonId = makeCollabJsonId;
/** @public */
function makeCollabId(objectClass, objectId, objectAttr) {
    return { objectClass, objectId, objectAttr };
}
/** @public */
function makeDocCollabId(doc, objectAttr) {
    return makeCollabId(doc._class, doc._id, objectAttr);
}
/** @public */
function makeCollabYdocId(doc) {
    const { objectId, objectAttr } = doc;
    return `${objectId}%${objectAttr}`;
}
/** @public */
function makeCollabJsonId(doc) {
    const timestamp = Date.now();
    const { objectId, objectAttr } = doc;
    return [objectId, objectAttr, timestamp].join('-');
}
//# sourceMappingURL=collaboration.js.map